import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { PlusCircle } from "feather-icons-react/build/IconComponents";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { ErrorToaster } from "../components/toaster/Toaster";
import { generatePdf } from "../../utils/helper";
import dayjs from "dayjs";
import { Table } from "antd";
import SaleInvoiceServices from "../../services/SaleInvoice";
import { useSelector } from "react-redux";
import StateServices from "../../services/State";

const SaleInvoice = () => {

  const invoiceRef = useRef(null);
  const { id } = useParams();
  const { userData } = useSelector((state) => {
    return {
      userData: state.user_data
    }
  });

  const storeLogo = userData?.store?.logoBase64 || '/assets/img/mattress-plus-logo.png'
  const storeQrCode = userData?.store?.qrCodeBase64 || '/assets/img/store/store-qr.png'

  // *For Loading
  const [loading, setLoading] = useState(false);

  // *For Sale Invoice Data
  const [saleInvoice, setSaleInvoice] = useState();
  const [billingDetail, setBillingDetail] = useState();
  const [shippingDetail, setShippingDetail] = useState();

  // *For Generate PDF
  const handleGeneratePdf = async () => {
    setLoading(true)
    try {
      await generatePdf([invoiceRef], 'sale-invoice')
    } catch (error) {
      console.log('handleGeneratePdf => error:', error)
    } finally {
      setLoading(false)
    }
  };

  const getInfoByZipCode = async (zipCode, type) => {
    try {
      if (zipCode.length == 5) {
        const { data } = await StateServices.getInfoByZipCode(zipCode)
        if (type == 'billing') {
          setBillingDetail(data[0])
        } else {
          setShippingDetail(data[0])
        }
      } else {
        return
      }
    } catch (error) {
      console.log(' getInfoByZipCode => error:', error)
      // ErrorToaster(error)
    }
  }

  // *For Get Sale Invoice Details
  const getSaleInvoiceDetails = async () => {
    try {
      const { data } = await SaleInvoiceServices.getSaleInvoiceById(id)
      setSaleInvoice(data[0])
      getInfoByZipCode(data[0]?.billing_zip_code, 'billing')
      getInfoByZipCode(data[0]?.shipping_zip_code, 'shipping')
    } catch (error) {
      ErrorToaster(error)
    }
  }

  useEffect(() => {
    if (id) {
      getSaleInvoiceDetails()
    }
  }, [id]);

  const columns = [
    {
      title: "Brand",
      dataIndex: "item",
      render: (text) => (
        <span>
          {text?.brand?.name}
        </span>
      ),
    },
    {
      title: "Product",
      dataIndex: "item",
      render: (text, record) => (
        <span>
          {text?.name}&nbsp;
          {record?.variant?.attributes &&
            Object.values(record?.variant?.attributes).join('-')
          }
        </span>
      ),
    },
    // {
    //   title: "Size",
    //   dataIndex: "size",
    //   render: (text) => (
    //     <span>
    //       {text?.name}
    //     </span>
    //   ),
    // },
    // {
    //   title: "Description",
    //   dataIndex: "description",
    //   render: (text) => (
    //     <span>
    //       {text}
    //     </span>
    //   ),
    // },
    {
      title: "Qty",
      dataIndex: "quantity",
      render: (text) => (
        <span>
          {text}
        </span>
      ),
    },
    {
      title: "Reg Price",
      dataIndex: "regular_price",
      render: (text) => (
        <span>
          ${parseFloat(text).toFixed(2)}
        </span>
      ),
    },
    {
      title: "Sale Price",
      dataIndex: "sales_price",
      render: (text) => (
        <span>
          ${parseFloat(text).toFixed(2)}
        </span>
      ),
    },
    {
      title: "Extended Total",
      dataIndex: "extended_total",
      render: (text) => (
        <span>
          ${parseFloat(text).toFixed(2)}
        </span>
      ),
    },
    {
      title: "Shipping Type",
      dataIndex: "delivery_type",
      render: (text) => (
        <span>
          {text?.name}
        </span>
      ),
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>View Sale Invoice</h4>
            </div>
          </div>
          <div className="page-btn">
            <button disabled={loading} className="btn btn-added" onClick={() => handleGeneratePdf()}>
              <PlusCircle className="me-2 iconsize" />
              Print
            </button>
          </div>
        </div>

        <div className="card-body mb-3">
          <div id='invoiceToPrint' className="card m-auto" style={{ width: '950px' }}>
            <div ref={invoiceRef}>
              <div className="card-body add-product p-4">
                <div className="row justify-content-between mb-1">
                  <div className="col-md-4">
                    <img src={storeLogo} alt="img" style={{ height: 'auto', width: 'auto', objectFit: 'contain' }} />
                    <p className="mb-1">{userData?.store?.address.split(',')[0]}</p>
                    <p className="mb-1">{userData?.store?.address.split(', ').splice(1).join(', ')}</p>
                    <p className="mb-1">{userData?.store?.phone_number}</p>
                  </div>
                  <div className="col-md-2">
                    <img src={storeQrCode} alt="img" style={{ height: 'auto', width: 'auto', objectFit: 'contain' }} />
                  </div>
                  <div className="col-md-5">
                    <h3 className="mb-1">INVOICE</h3>
                    <div className="row">
                      <div className="col-md-4">
                        <p>Purchase Date:</p>
                      </div>
                      <div className="col-md-8">
                        <p>{dayjs(saleInvoice?.order_date).format('MM-DD-YYYY')}</p>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-4">
                        <p>Order:</p>
                      </div>
                      <div className="col-md-8">
                        <p>{saleInvoice?.order_number}</p>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-4">
                        <p>Delivery Date:</p>
                      </div>
                      <div className="col-md-8">
                        <p>{dayjs(saleInvoice?.delivery_date).format('MM-DD-YYYY')} / {saleInvoice?.delivery_day}</p>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-4">
                        <p>Time Frame:</p>
                      </div>
                      <div className="col-md-8">
                        <p>{saleInvoice?.delivery_time_slot?.name}</p>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-4">
                        <p>Sale Person:</p>
                      </div>
                      <div className="col-md-8">
                        <p>
                          {saleInvoice?.salespersons.map((item) => item.name).join(', ')}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row justify-content-between">
                  <div className="col-md-5">
                    <h6 className="text-center py-1" style={{ backgroundColor: 'rgb(0,176,240)', color: '#fff' }}>Billing Info</h6>
                    <div className="row">
                      <div className="col-md-4">
                        <p>Name:</p>
                      </div>
                      <div className="col-md-8">
                        <p>{saleInvoice?.billing_name} {saleInvoice?.billing_last_name}</p>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-4">
                        <p>Address:</p>
                      </div>
                      <div className="col-md-8">
                        <p>{saleInvoice?.billing_address}, {billingDetail?.city?.name} {billingDetail?.state?.name} {saleInvoice?.billing_zip_code}</p>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-4">
                        <p>Phone:</p>
                      </div>
                      <div className="col-md-8">
                        <p>{saleInvoice?.billing_phone_number_one}, {saleInvoice?.billing_phone_number_two}</p>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-4">
                        <p>Email:</p>
                      </div>
                      <div className="col-md-8">
                        <p>{saleInvoice?.billing_email}</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-5">
                    <h6 className="text-center py-1" style={{ backgroundColor: 'rgb(0,176,240)', color: '#fff' }}>Delivery Info</h6>
                    <div className="row">
                      <div className="col-md-4">
                        <p>Name:</p>
                      </div>
                      <div className="col-md-8">
                        <p>{saleInvoice?.shipping_name} {saleInvoice?.shipping_last_name}</p>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-4">
                        <p>Address:</p>
                      </div>
                      <div className="col-md-8">
                        <p>{saleInvoice?.shipping_address}, {shippingDetail?.city?.name} {shippingDetail?.state?.name}, {saleInvoice?.shipping_zip_code}</p>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-4">
                        <p>Phone:</p>
                      </div>
                      <div className="col-md-8">
                        <p>{saleInvoice?.shipping_phone_number_one}, {saleInvoice?.shipping_phone_number_two}</p>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-4">
                        <p>Email:</p>
                      </div>
                      <div className="col-md-8">
                        <p>{saleInvoice?.shipping_email}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mb-2">
                  <div className="addproduct-icon" style={{ paddingBottom: '10px', marginBottom: '10px' }}>
                  </div>
                  <Table
                    className="table datanew dataTable no-footer custom-table"
                    columns={columns}
                    dataSource={saleInvoice?.sale_invoice_items}
                    pagination={false}
                  />
                  <div className="row mt-3 mb-1">
                    <div className="col-lg-6 col-sm-6 col-12">
                      <p>{saleInvoice?.service_type?.remark} {`(charges ${parseFloat(saleInvoice?.service_type?.price).toFixed(2)})`}</p>
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-lg-4">
                      <div className="total-order w-100 max-widthauto m-auto ">
                        <p><b>Comments</b>: {saleInvoice?.comments}</p>
                        {/* <ul>
                          <li>
                            <h4>Total</h4>
                            <h5>$ 5456</h5>
                          </li>
                          <li>
                            <h4>Saving</h4>
                            <h5>$ 5456</h5>
                          </li>
                        </ul> */}
                      </div>
                    </div>
                    <div className="col-lg-4 ms-auto">
                      <div className="row">
                        <div className="col-md-8">
                          <p>Sub Total:</p>
                        </div>
                        <div className="col-md-4">
                          <p>${parseFloat(saleInvoice?.sub_total).toFixed(2)}</p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-8">
                          <p>Sale Tax:</p>
                        </div>
                        <div className="col-md-4">
                          <p>${parseFloat(saleInvoice?.sales_tax).toFixed(2)}</p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-8">
                          <p>Grand Total:</p>
                        </div>
                        <div className="col-md-4">
                          <p>${parseFloat(saleInvoice?.total_sale).toFixed(2)}</p>
                        </div>
                      </div>
                      {saleInvoice?.invoice_payments.map((payment, index) => (
                        <div key={index} className="row">
                          <div className="col-md-8">
                            <p>{payment?.payment_head?.name}:</p>
                          </div>
                          <div className="col-md-4">
                            <p>${parseFloat(payment?.received_amount).toFixed(2)}</p>
                          </div>
                        </div>
                      ))}
                      {/* <div className="row">
                        <div className="col-md-8">
                          <p>Bank:</p>
                        </div>
                        <div className="col-md-4">
                          <p>$42</p>
                        </div>
                      </div> */}
                      {/* <div className="row">
                        <div className="col-md-8">
                          <p>Balance Amount:</p>
                        </div>
                        <div className="col-md-4">
                          <p>${parseFloat(saleInvoice?.balance_amount).toFixed(2)}</p>
                        </div>
                      </div> */}
                      {/* <div className="total-order w-100 max-widthauto m-auto mb-4">
                        <ul>
                          <li>
                            <h4>Sub Total</h4>
                            <h5>$ 456</h5>
                          </li>
                          <li>
                            <h4>Sale Tax</h4>
                            <h5>$ 4563</h5>
                          </li>
                          <li>
                            <h4>Grand Total</h4>
                            <h5>$ 5456</h5>
                          </li>
                          <li className="justify-content-between">
                            <h4>Received Amount 1</h4>
                            <h5>$ 5456</h5>
                          </li>
                          <li className="justify-content-between">
                            <h4>Received Amount 2</h4>
                            <h5>$ 5456</h5>
                          </li>
                          <li className="justify-content-between">
                            <h4>Received Amount 3</h4>
                            <h5>$ 5456</h5>
                          </li>
                          <li>
                            <h4>Balance Amount</h4>
                            <h5>$ 5462</h5>
                          </li>
                        </ul>
                      </div> */}
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-lg-8">
                      <div className="total-order w-100 max-widthauto m-auto ">
                        <p>Thank you for shopping at MATTRESS PLUS, you saved <b>${parseFloat(saleInvoice?.total_savings).toFixed(2)}</b></p>
                      </div>
                    </div>
                    <div className="col-lg-4 ms-auto">
                      <div className="row">
                        <div className="col-md-8">
                          <p><b>Balance Amount</b>:</p>
                        </div>
                        <div className="col-md-4">
                          <p><b>${parseFloat(saleInvoice?.balance_amount).toFixed(2)}</b></p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div >
  );
};

export default SaleInvoice;
